import type { Klantgegevens } from '../types/Klantgegevens'

/**
 * Check if any of the actual properties in Klantgegevens are populated
 */
export const hasAnyKlantgegevens = (
  gegevens: Partial<Klantgegevens>,
): boolean => {
  if (!gegevens || typeof gegevens !== 'object') {
    return false
  }

  const keysToCheck: (keyof Klantgegevens)[] = [
    'aanvrager',
    'contactPersoon',
    'bedrijfsnaam',
    'isBedrijf',
    'isProfessioneel',
    'omschrijving',
    'bijlagen',
    'gerelateerdeAanvragen',
  ]

  return keysToCheck.some(
    (key) => gegevens[key] !== undefined && gegevens[key] !== null,
  )
}
